import store from 'dashboard/store'
import app from '../../app';

/**
 * Router hook enabled-module-guard.js
 *
 * @namespace enabled-module-guard
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/router/hooks/enabled-module-guard.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */


/**
 * Allows user to navigate to enabled module screens
 * @function
 * @memberof enabled-module-guard
*/
export default async (to, from, next) => {
    if (!await redirectIfBehaviourModulesAreNotEnabled(to.meta?.enabledBehaviourModules, to, next)){
        next()
    }
}

/**
 * Checks if module is enabled, if not redirects to Alerts / Patient overview screen
 * @function redirectIfBehaviourModulesAreNotEnabled
 * @memberof enabled-module-guard
 */
export const redirectIfBehaviourModulesAreNotEnabled = async (enabledBehaviourModules, to, next, patientId = null) => {
    patientId = patientId ? patientId : store.getters['patientSummary/id']

    // Make sure enabled modules are loaded from backend.
    if (store.state.authToken){
        // redirect non standard users to report page.
        if (!store.getters['user/isStandardDashboardUser']) {
            if (to.name !== 'Reports') {
                return next({ name: 'Reports' });
            } else {
                return next();
            }
        }

        await store.dispatch('enabledModules/getEnabledModules');
    }

    if (enabledBehaviourModules) {
        for (let i=0; i<enabledBehaviourModules.length ; i++){
            const requiredBehaviourModule = enabledBehaviourModules[i];

            if (!store.getters['enabledModules/getIsModuleEnabled'](requiredBehaviourModule)){
                if (app.env.NODE_ENV === 'development') {
                    console.warn(`Page (${to.fullPath}) not accessible because the following module is not enabled: ${requiredBehaviourModule}`)
                }
                if (patientId) {
                    return next({name: 'PatientOverview', params: {patientId}})
                } else {
                    return next({ name: 'Alerts' })
                }
            }
        }
    }

    return null
}
